import React, { PureComponent } from 'react';
import Radium from 'radium';
import { Field } from 'redux-form';
import { any } from 'prop-types';
import { DeleteForever } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { required, email as emailValidation, maxLength } from '@widergy/web-utils/lib/validate';
import { UTTextInput } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

import Header from '../Header';

import styles from './styles';

class Emails extends PureComponent {
  validate = [
    required(message('Translation:fieldRequired')),
    emailValidation(message('Signup:emailFormat')),
    maxLength(appConfig.userDataManagement.emailMaxLength, message('Validations:invalidFormat'))
  ];

  handleAddEmail = () => this.props.fields.push({});

  handleDeleteEmail = index => this.props.fields.remove(index);

  render() {
    return (
      <React.Fragment>
        <Header title={message('Configuration:emailsTitle')} onAdd={this.handleAddEmail} />
        {this.props.fields.map((email, index) => (
          <div key={email} style={styles.container}>
            <Field
              name={`${email}.email`}
              label={message('Commons:email')}
              component={UTTextInput}
              validate={this.validate}
            />
            <IconButton style={styles.deleteButton} onClick={() => this.handleDeleteEmail(index)}>
              <DeleteForever />
            </IconButton>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

Emails.propTypes = {
  fields: any // eslint-disable-line react/forbid-prop-types
};

export default Radium(Emails);
